import {ChangeDetectorRef, Component, Input, OnInit, HostBinding} from '@angular/core';
import SwiperCore, {Pagination, EffectFade, Autoplay} from 'swiper/core';
import {environment} from 'src/environments/environment';

// Enable Swiper Paginate, Fade Effect and Autoplay
SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-progress-custom',
    templateUrl: './pb-progress-custom.component.html',
    styleUrls: ['./pb-progress-custom.component.scss']
})
export class PbProgressCustomComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    paddingTop: any = '';
    paddingBottom: any = '';
    items: any = [];

    swiperInstance: any;
    domainUrl: string = environment.webUrl;

    slides: any = [];

    public responsivePartialOverflowConfig: any = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        // freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        centerInsufficientSlides: true,
        pagination: {clickable: true},
        breakpoints: {
            576: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 3.2
            },
            992: {
                slidesPerView: 4
            }
        }
    };

    constructor() {}

    ngOnInit(): void {

        this.content.forEach(element => {
            const item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                marginClass: this.determineMarginClass(element.alignment),
                type: element.item.type,
                icon: ''
            };

            try {
                item.content = JSON.parse(item.content);
            } catch (err) {
                console.error('JSON parse error: ', err);
            }

            if (item.content.icon !== '') {
                item.icon = this.domainUrl + '/' + item.content?.icon;
            }

            this.slides.push(item);
        });

    }

    /**
     * When the 'Progress Custom' swiper is ready, then run the update so that the slide size is correct
     * @param swiper
     */
    onProgressCustomSwiper(swiper) {

        this.swiperInstance = swiper;

        setTimeout(() => {
            // swiper.update();
        }, 1500);

    }

    @HostBinding('attr.style')
    public get cssVars() {
        return `
            --card-body-padding: ${this.slides[0].content?.padding ? this.slides[0].content?.padding + 'px' : '2.25rem'};
        `;
    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment === 'LEFT') {
            return 'text-left';
        } else if (alignment === 'CENTER') {
            return 'text-center';
        } else if (alignment === 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineMarginClass(alignment) {

        if (alignment === 'LEFT') {
            return 'mr-auto';
        } else if (alignment === 'CENTER') {
            return 'mx-auto';
        } else if (alignment === 'RIGHT') {
            return 'ml-auto';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

}
